import update from "immutability-helper";

import {
  POLLS_LOADING_START,
  POLLS_LOADING_SUCCESS,
  POLLS_LOADING_FAILED,
  CHANGE_POLLS_PAGE,
  CHANGE_POLLS_LIMIT,
  SWITCH_POLLS_FILTER,
  //Восстановление отчета
  POLL_RESTORED_SUCCESSFULLY,
} from '../actions/pollsList';

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  ready: false,
  loading: false,
  polls: [],
  total: 0,
  limit: 15,
  activePage: 1,
  filters: {
    clients: false,
    consultants: false,
    all: false,
  }
};

export default function (state = INITIAL_STATE, action) { 
  switch (action.type) {
    case POLLS_LOADING_START:
      return {
        ...state,
        ready: false,
        loading: true,
        polls: [],
        total: 0,
      };
    case POLLS_LOADING_SUCCESS:
      return {
        ...state,
        ready: true,
        loading: false,
        polls: action.payload.polls.polls,
        total: parseInt(action.payload.polls.total, 10),
      };
    case POLLS_LOADING_FAILED:
      return {
        ...state,
        ready: false,
        loading: false,
      };
    //Пагинация
    case CHANGE_POLLS_PAGE:
      return {
        ...state,
        activePage: action.payload.activePage,
      };
    case CHANGE_POLLS_LIMIT:
      return {
        ...state,
        limit: action.payload.activeLimit,
        activePage: INITIAL_STATE.activePage,
      };
    //Фильтры
    case SWITCH_POLLS_FILTER:
      return update(state, {
        filters: {
          [action.payload.filter]: {$set: !state.filters[action.payload.filter]},
        }
      });
    //Восстановление отчета
    case POLL_RESTORED_SUCCESSFULLY:
      return update(state, {
        polls: {
          [action.payload.pollIndex]: {
            status: {$set: action.payload.status},
          }
        },
      });
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}